import React, { ReactNode } from 'react';
import colors from 'styles/export/colors.module.scss';

type Props = {
	icon?: ReactNode;
	value: string;
	subLabel: string;
	onClick?: () => void;
};

// padding-right reserva espaço para o botão X de remover widget (WidgetWrapper).
const wrapperStyle: React.CSSProperties = { display: 'flex', alignItems: 'center', gap: 10, paddingRight: 9 };
const iconBoxStyle: React.CSSProperties = {
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: 30,
	height: 30,
	borderRadius: 6,
	backgroundColor: '#f4f4f4',
	color: colors.primaryDark,
	fontSize: 14,
	flexShrink: 0,
};
const valueStyle: React.CSSProperties = { fontSize: 18, fontWeight: 700, lineHeight: 1.1, color: colors.black, textAlign: 'right' };
const subStyle: React.CSSProperties = { fontSize: 11, color: colors.frenchGray, marginTop: 2, textAlign: 'right' };

const InlineKpiCounter = ({ icon, value, subLabel, onClick }: Props) => {
	const rootStyle: React.CSSProperties = onClick ? { ...wrapperStyle, cursor: 'pointer' } : wrapperStyle;
	return (
		<div style={rootStyle} onClick={onClick} role={onClick ? 'button' : undefined} tabIndex={onClick ? 0 : undefined}>
			{icon && <span style={iconBoxStyle}>{icon}</span>}
			<div>
				<div style={valueStyle}>{value}</div>
				<div style={subStyle}>{subLabel}</div>
			</div>
		</div>
	);
};

export default InlineKpiCounter;
